
import { BasicModel } from "@goodgamestudios/core";
import { BasicStandardYesNoDialogProperties } from "@goodgamestudios/core";
import { SFConstants } from "../../constants/SFConstants";
import { Poker2DialogEvent } from "../../event/Poker2DialogEvent";
import { Poker2UserEvent } from "../../event/Poker2UserEvent";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2Screen } from "./Poker2Screen";

import DisplayObject = createjs.DisplayObject;

import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;

export class Poker2BoosterScreen extends Poker2Screen {
    public static NAME: string = "Poker2BoosterScreen";

    private X_POS: number = 135;
    private Y_POS: number = 305;

    private selectedBoosterId: number = 0;
    private boosterComponent: Poker2BoosterComponent;

    constructor(disp: DisplayObject) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    public show(): void {
        super.show();
        this.controller.addEventListener("changeBooster", this.bindFunction(this.onChangeBooster));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2BoosterScreen", 1]));

        this.boosterComponent.fillItems();
        this.boosterComponent.fillOwnBooster();
    }

    protected init(): void {
        super.init();
        this.boosterComponent = new Poker2BoosterComponent(this.boosterScreen);
        this.boosterScreen.btn_close.visible = false;

        this.boosterScreen.bg.doCache(0, 2);
    }

    public hide(): void {
        super.hide();
        this.controller.removeEventListener("changeBooster", this.bindFunction(this.onChangeBooster));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2BoosterScreen", 0]));
    }

    protected applyProperties(): void {
        super.applyProperties();
        this.boosterComponent.applyProperties();
    }

    private onChangeBooster(event: Event): void {
        this.boosterComponent.fillItems();
        this.boosterComponent.fillOwnBooster();
    }

    private validateBooster(boosterId: number): void {
        this.selectedBoosterId = boosterId;

        //TIME UPGRADE
        if (Poker2Model.inventoryData.hasBoosterByWodId(boosterId)) {
            this.layoutManager.showDialog(Poker2StandardYesNoDialog.NAME, new BasicStandardYesNoDialogProperties(Poker2Model.languageData.getTextById("generic_alert_information"), Poker2Model.languageData.getTextById("dialog_buybooster_extend"), this.bindFunction(this.buyBooster)));
        }
        else if (!Poker2Model.inventoryData.hasBoosterByWodId(boosterId) && !Poker2Model.inventoryData.hasHigherBooster(boosterId)) {
            //BUY ACTION
            if (!Poker2Model.inventoryData.hasHigherBooster(boosterId) && !Poker2Model.inventoryData.hasLowerBooster(boosterId))
                this.buyBooster(null);
            else
                //OVERRIDE
                if (Poker2Model.inventoryData.hasLowerBooster(boosterId))
                    this.layoutManager.showDialog(Poker2StandardYesNoDialog.NAME, new BasicStandardYesNoDialogProperties(Poker2Model.languageData.getTextById("generic_alert_information"), Poker2Model.languageData.getTextById("dialog_buybooster_override"), this.bindFunction(this.buyBooster)));
        }

    }

    private buyBooster(params: any[]): void {
        if (this.selectedBoosterId >= 0)
            BasicModel.smartfoxClient.sendMessage("bbu", [JSON.stringify({ id: this.selectedBoosterId })]);
    }

    protected onMouseOver(event: MouseEvent): void {
        super.onMouseOver(event);

        if (event.target == this.boosterScreen.btn_info)
            this.boosterScreen.mc_info.visible = true;
    }

    protected onMouseOut(event: MouseEvent): void {
        super.onMouseOut(event);

        if (event.target == this.boosterScreen.btn_info)
            this.boosterScreen.mc_info.visible = false;
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        switch (event.target) {
            case this.boosterScreen.btn_close:
                this.hide();
                break;
            case this.boosterScreen.booster0.btn_buy:
            case this.boosterScreen.booster1.btn_buy:
            case this.boosterScreen.booster2.btn_buy:
            case this.boosterScreen.booster3.btn_buy:
                this.validateBooster(event.target.boosterId);
                break;
        }
    }

    public updatePosition(): void {
        if (this.disp && this.disp.stage) {
            this.disp.scaleX = this.disp.scaleY = this.layoutManager.scaleFactor;
            this.disp.x = ((800 / 2 + this.X_POS) * this.disp.scaleX) + this.layoutManager.gameNullPoint;
            this.disp.y = (this.Y_POS * this.layoutManager.scaleFactor);
        }
    }

    public get boosterScreen(): Library.PokerInterface.PokerBooster {
        return this.disp as Library.PokerInterface.PokerBooster;
    }
}
import { Poker2BoosterComponent } from "../components/booster/Poker2BoosterComponent";
import { Poker2StandardYesNoDialog } from "../dialogs/Poker2StandardYesNoDialog";
import { Poker2LayoutManager } from "../Poker2LayoutManager";
